import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map';
import '@/assets/flexible.js'
import '@/plugins' // 引入插件配置
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(BaiduMap,{
  ak:'6kw2pvn0h71KbPBhZFzL6uVGtfGnpQiI'
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  Vue.prototype.$ISMOBILE = window.innerWidth <= 700
  next()
})

new Vue({
  router,

  render: h => h(App)
}).$mount('#app')
